import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Table from 'components/Table/index';
import { Tag, Space, Button } from 'antd';
import { getColorStatus } from 'utils/funcaoPadrao';
import { convertDatePtBrHs } from 'utils/dateFormatter';
import { fetchDetalharFormularioPorId } from 'store/fetchActions/fetchFormulario';
import { fetchSalvarLocalFiltroRequerimento } from 'store/fetchActions/fetchInputForm';
import { fetchObterHistoricoPorId } from 'store/fetchActions/fetchHistorico';
import { useHistory } from 'react-router-dom';
import { fetchUpdateDadosMinimizados } from 'store/fetchActions/fetchApp';

export default function GridRequerimento({ filtros, handlePesquisar }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const configFiltroSalvo = useSelector(state => state.formulario.configFiltroPesquisa);
  const dadosGrid = useSelector(state => state.formulario.todosFormularios?.list);
  const paginacao = useSelector(state => state.formulario.todosFormularios);

  const [pageConfig, setPageConfig] = React.useState(configFiltroSalvo);

  const montarLinha = lista => {
    return lista?.map(item => {
      return {
        key: item?.id,
        protocolo: item?.localizador,
        dataAbertura: convertDatePtBrHs(item?.dataAbertura),
        assunto: item?.assunto?.descricao,
        status: { statusId: item?.status?.id, status: item?.status?.descricao },
        dataEncerramento: convertDatePtBrHs(item?.dataEncerramento) || '-',
        tempoParado: item?.tempoParado,
      };
    });
  };

  const renderTag = tag => {
    return (
      <Tag {...getColorStatus(tag?.statusId)} key={tag}>
        {tag?.status?.toUpperCase()}
      </Tag>
    );
  };

  const onDetalhar = (key, history) => {
    dispatch(fetchUpdateDadosMinimizados({}));
    dispatch(fetchDetalharFormularioPorId(key, history));
    dispatch(fetchSalvarLocalFiltroRequerimento(filtros, pageConfig?.page, pageConfig?.pageSize));
  };

  const renderAction = row => {
    return (
      <Space>
        <Button onClick={() => dispatch(fetchObterHistoricoPorId(row?.key))}>Histórico</Button>
        <Button onClick={() => onDetalhar(row?.key, history)}>Detalhar</Button>
      </Space>
    );
  };

  const changePage = (page = 1, pageSize = 10) => {
    handlePesquisar(filtros, page, pageSize);
    setPageConfig({ page, pageSize });
  };

  const columns = [
    {
      title: 'Protocolo',
      dataIndex: 'protocolo',
      key: 'protocolo',
    },
    {
      title: 'Data de Abertura',
      dataIndex: 'dataAbertura',
      key: 'dataAbertura',
    },
    {
      title: 'Assunto',
      dataIndex: 'assunto',
      key: 'assunto',
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: tag => renderTag(tag),
    },
    {
      title: 'Tempo no Status',
      key: 'tempoParado',
      dataIndex: 'tempoParado',
    },
    {
      title: 'Data Encerramento',
      dataIndex: 'dataEncerramento',
      key: 'dataEncerramento',
    },
    {
      title: '-',
      key: 'action',
      align: 'center',
      render: record => renderAction(record),
    },
  ];

  return <Table columns={columns} data={montarLinha(dadosGrid)} paginationConfig={paginacao} changePage={changePage} />;
}
